import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Home from '@/components/Home/Home'
import Setting from '@/components/Setting/Setting'
import PageNotFound from '@/components/Partials/PageNotFound'
import Patient from '@/components/Patient/Patient';
import PatientFill from '@/components/Patient/Fill/Fill';
import PatientTrash from '@/components/Patient/Trash/Trash.vue';
import AddNewPatient from '@/components/Patient/NewPatient/NewPatient.vue';
import TownshipChoose from '@/components/Patient/TownshipChoose/TownshipChoose.vue';

import VolunteerTownshipChoose from '@/components/Volunteer/TownshipChoose/TownshipChoose.vue'
import Volunteer from '@/components/Volunteer/Volunteer'
import VolunteerList from '@/components/Volunteer/List/VolunteerList';
import VolunteerBlockList from '@/components/Volunteer/BlockList/BlockList';
import VolunteerTrashList from '@/components/Volunteer/TrashList/TrashList';
import AddNewVolunteer from '@/components/Volunteer/AddNew'
import EditVolunteer from '@/components/Volunteer/Edit'
import EachVolunteer from '@/components/Volunteer/View/EachVolunteer';
import VolunteerAddTraining from '@/components/Volunteer/AddTraining.vue';

import SCCTownshipChoose from '@/components/SCC/SCCTownshipChoose.vue'
import SCC from '@/components/SCC/SCC.vue'

import ActivityChooseBox from '@/components/Activities/ChooseBox.vue';
import Activities from '@/components/Activities/Activities.vue';
import EachActivity from '@/components/Activities/EachActivity.vue';
import NewActivity from '@/components/Activities/NewActivity.vue';
import EditActivity from '@/components/Activities/EditActivity.vue';

import ReferList from '@/components/Patient/Refer/List.vue';
import NewRefer from '@/components/Patient/Refer/AddNew.vue';
import EditRefer from '@/components/Patient/Refer/Edit.vue';
import TrashRefer from '@/components/Patient/Refer/Trash.vue';


import { islogin } from './../misc/auth.js';

Vue.use(Router)

var router = new Router({
  mode: "history",
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
      meta: {
        auth: true
      }
    },
    {
      path: '/setting',
      name: 'Setting',
      component: Setting,
      meta: {
        auth: true
      }
    },
    {
      path: '/townshipchoose',
      name: 'TownshipChoose',
      component: TownshipChoose,
      meta: {
        auth: true
      }
    },
    {
      path: '/patients/:township_id/township',
      name: 'Patient',
      component: Patient,
      meta: {
        auth: true
      }
    },
    {
      path: '/patients/trash',
      name: 'PatientTrash',
      component: PatientTrash,
      meta: {
        auth: true
      }
    },
    {
      path: '/patients/:search/search',
      name: 'PatientSearch',
      component: Patient,
      meta: {
        auth: true
      }
    },
    {
      path: '/patient/fill/:id',
      name: 'PatientFill',
      component: PatientFill,
      meta: {
        auth: true
      }
    },
    {
      path: '/patient/new/:township_id',
      name: 'AddNewPatient',
      component: AddNewPatient,
      meta: {
        auth: true
      }
    },

    {
      path: '*',
      name: 'PageNotFound',
      component: PageNotFound
    },

    {
      path: '/volunteer/blocklist/:township_id',
      name: 'VolunteerBlockList',
      component: VolunteerBlockList,
      meta: {
        auth: true
      }
    },

    {
      path: '/volunteer/trashlist/:township_id',
      name: 'VolunteerTrashList',
      component: VolunteerTrashList,
      meta: {
        auth: true
      }
    },

    {
      path: '/volunteer_township_choose',
      name: 'VolunteerTownshipChoose',
      component: VolunteerTownshipChoose,
      meta: {
        auth: true
      }
    },
    {
      path: '/volunteers/:township_id',
      name: 'Volunteer',
      component: Volunteer,
      meta: {
        auth: true
      }
    },
    ,
    {
      path: '/volunteer/addnew/:township_id',
      name: 'AddNewVolunteer',
      component: AddNewVolunteer,
      meta: {
        auth: true
      }
    },
    ,
    {
      path: '/volunteer/:id/edit',
      name: 'EditVolunteer',
      component: EditVolunteer,
      meta: {
        auth: true
      }
    },

    {
      path: '/volunteer/list/:township_id',
      name: 'VolunteerList',
      component: VolunteerList,
      meta: {
        auth: true
      }
    },


    {
      path: '/volunteer/list/:township_id/:search/search',
      name: 'VolunteerListSearch',
      component: VolunteerList,
      meta: {
        auth: true
      }
    },
    {
      path: '/volunteer/blocklist/:township_id/:search/search',
      name: 'VolunteerBlockListSearch',
      component: VolunteerBlockList,
      meta: {
        auth: true
      }
    },
    {
      path: '/volunteer/blocklist/:township_id/:search/search',
      name: 'VolunteerTrashListSearch',
      component: VolunteerTrashList,
      meta: {
        auth: true
      }
    },


    {
      path: '/volunteer/:id',
      name: 'VolunteerView',
      component: EachVolunteer,
      meta: {
        auth: true
      }
    },
    {
      path: '/volunteer/training/add/:id',
      name: 'VolunteerAddTraining',
      component: VolunteerAddTraining,
      meta: {
        auth: true
      }
    },
    {
      path: '/scc/township_choose',
      name: 'SCCTownshipChoose',
      component: SCCTownshipChoose,
      meta: {
        auth: true
      }
    },
    {
      path: '/scc/:township_id',
      name: 'SCC',
      component: SCC,
      meta: {
        auth: true
      }
    },
    {
      path: '/activity/choosebox',
      name: 'ActivityChooseBox',
      component: ActivityChooseBox,
      meta: {
        auth: true
      }
    },
    {
      path: '/activities/:year/:month/:township_id',
      name: 'Activities',
      component: Activities,
      meta: {
        auth: true
      }
    },
    {
      path: '/activities/:id/:year/:month/:township_id',
      name: 'EachActivity',
      component: EachActivity,
      meta: {
        auth: true
      }
    },
    {
      path: '/activities/:id/:year/:month/:township_id/new',
      name: 'NewActivity',
      component: NewActivity,
      meta: {
        auth: true
      }
    },
    {
      path: '/edit/:id/activities/:township_id',
      name: 'EditActivity',
      component: EditActivity,
      meta: {
        auth: true
      }
    },
    {
      path: '/patient/refer/:township_id',
      name: 'ReferList',
      component: ReferList,
      meta: {
        auth: true
      }
    },
    {
      path: '/refer/new/:township_id',
      name: 'NewRefer',
      component: NewRefer,
      meta: {
        auth: true
      }
    },
    {
      path: '/refer/edit/:patient_id',
      name: 'EditRefer',
      component: EditRefer,
      meta: {
        auth: true
      }
    },
    {
      path: '/refer/trash/:township_id',
      name: 'TrashRefer',
      component: TrashRefer,
      meta: { 
               auth:true
      }
    },
    

    

  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.auth)) {

    if (islogin("admin")) {

      next();
    }
    else {

      next({ name: 'Login' })
    }
  }
  else {
    next();
  }

})


export default router;